const MAPS = {
    lock: [
        "............",
        "....####....",
        "...#....#...",
        "...#....#...",
        "...#....#...",
        "..########..",
        "..#......#..",
        "..#..##..#..",
        "..#..##..#..",
        "..#......#..",
        "..########..",
        "............",
    ],
    floppy: [
        "############",
        "#........##",
        "#..####..##",
        "#..####..#.",
        "#..####..#.",
        "#........#.",
        "#........#.",
        "#..#####..#",
        "#..#...#..#",
        "#..#...#..#",
        "#..#####..#",
        "############",
    ],
    mac: [
        "............",
        ".##########.",
        ".#........#.",
        ".#.##..##.#.",
        ".#.##..##.#.",
        ".#........#.",
        ".#........#.",
        ".#.#....#.#.",
        ".#..####..#.",
        ".#........#.",
        ".##########.",
        "............",
    ],
    person: [
        "............",
        "....####....",
        "...######...",
        "...######...",
        "....####....",
        "............",
        "..######....",
        ".########...",
        ".########...",
        ".########...",
        ".########...",
        "............",
    ],
    doc: [
        ".########...",
        ".#.....##...",
        ".#.####.#...",
        ".#......#...",
        ".#.####.#...",
        ".#......#...",
        ".#.####.#...",
        ".#......#...",
        ".#......#...",
        ".########...",
        "............",
        "............",
    ],
    mail: [
        "............",
        ".##########.",
        ".##......##.",
        ".#.#....#.#.",
        ".#..#..#..#.",
        ".#...##...#.",
        ".#........#.",
        ".#........#.",
        ".##########.",
        "............",
        "............",
        "............",
    ],
    photo: [
        ".##########.",
        ".#........#.",
        ".#..##....#.",
        ".#..##....#.",
        ".#........#.",
        ".#.....#..#.",
        ".#....##..#.",
        ".#..#.##..#.",
        ".##.####.##.",
        ".##########.",
        "............",
        "............",
    ],
};

export default function PixelIcon({ name, dark = false, className = "h-4 w-4" }) {
    const rows = MAPS[name] || MAPS.mac;
    return (
        <svg
            viewBox={`0 0 ${rows[0].length} ${rows.length}`}
            shapeRendering="crispEdges"
            className={className}
            aria-hidden="true"
        >
            {rows.flatMap((row, y) =>
                [...row].map((c, x) =>
                    c === "#" ? (
                        <rect
                            key={`${x}-${y}`}
                            x={x}
                            y={y}
                            width="1"
                            height="1"
                            fill={dark ? "#fff" : "#000"}
                        />
                    ) : null,
                ),
            )}
        </svg>
    );
}
